// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__t8Duk","itemTitle":"style_itemTitle__R3nIn","item":"style_item__VhV_u","list":"style_list__0fBG8"};